import React, { useState } from "react";

import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";

const HoldOrderDialog = ({ visible, onHide, onConfirm }) => {
  const [description, setDescription] = useState("");

  const handleSubmit = () => {
    onConfirm(description);
    setDescription("");
  };

  return (
    <Dialog
      header="Hold Order"
      visible={visible}
      onHide={onHide}
      style={{ width: "500px" }}
      footer={
        <div>
          <Button
            label="Cancel"
            icon="pi pi-times"
            onClick={onHide}
            className="p-button-text"
          />
          <Button
            label="Hold Order"
            icon="pi pi-pause"
            onClick={handleSubmit}
            autoFocus
          />
        </div>
      }
    >
      <div className="p-fluid">
        <div className="p-field">
          <label htmlFor="description">Reason for holding the order *</label>
          <InputTextarea
            id="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={4}
            autoResize
            required
            placeholder="Enter the reason for holding this order..."
          />
        </div>
      </div>
    </Dialog>
  );
};

export default HoldOrderDialog; 